export function isInAppBrowser() {
  const ua = window.navigator.userAgent || '';
  const inAppPatterns = [
    /LinkedInApp/i,
    /FBAN|FBAV|FB_IAB|FB4A/i, // Facebook
    /Instagram/i,
    /Snapchat/i,
    /Pinterest/i,
    /Twitter/i,
    /WhatsApp/i,
    /Messenger/i,
  ];
  return inAppPatterns.some((rx) => rx.test(ua));
}
